import { CloudOff } from 'lucide-react';
import { ReactNode } from 'react';

interface TimelineListProps {
  children: ReactNode;
}

/**
 * Container for timeline entries.
 * Renders a list with proper spacing, or an empty-state dot when there are no entries.
 */
export function TimelineList({ children }: TimelineListProps) {
  return (
    <ul role="list" className="mt-6 space-y-12">
      <div className="space-y-4">{children}</div>
    </ul>
  );
}

/** Empty state notice. */
export function TimelineEmpty({
  message = 'No activity yet.',
}: { message?: string } = {}) {
  return <p className="text-muted-foreground mt-4 text-sm italic">{message}</p>;
}

/**
 * Marks where the history held runs out rather than ends. Render it as the
 * LAST child: the shell reverses its children for the oldest-first
 * preference, which keeps the notice at the oldest end either way.
 */
export function TimelineTruncated({
  message = 'Earlier history has not been downloaded. Reconnect to load it.',
}: { message?: string } = {}) {
  return (
    <li className="text-muted-foreground flex items-center gap-2 text-sm italic">
      <CloudOff className="size-4 shrink-0" aria-hidden />
      {message}
    </li>
  );
}
